export default __webpack_public_path__ + "89545ebbd9b7694de28eee519b21b03d.svg";